import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useTirePressure from '@di-shared/features/diag/tire/useTirePressure';
import {ccWebviewUtils} from '@cci-shared/features/webviewUtils';
import {ROUTE_PATHS} from '@di-shared/routes';

interface RecommendedTirePressureProps {
  vin: string;
}

function RecommendedTirePressure({vin}: RecommendedTirePressureProps) {
  const {t} = useInferableTranslation();
  const {
    registeredFrontTire,
    registeredRearTire,
    registeredFrontTireBound,
    registeredRearTireBound,
    isFrontRearSameTire,
    registeredTire,
    isRecommendedTireSingleSpec,
    pressureUnit,
    canChangeTireSpec,
    refetchTireRecommended,
    refetchTireBoundData,
  } = useTirePressure(vin);

  async function openTireSelectionModal() {
    const isChange = await ccWebviewUtils.openBottomSheetWebViewUrl<boolean>(ROUTE_PATHS.BOTTOM_SHEET_DIAG_TIRE_SELECTION.getFullPath(vin));
    if (isChange) {
      refetchTireRecommended();
      refetchTireBoundData();
    }
  }

  return (
    <>
      <div className="section_container recommend_pressure">
        <div className="section_container_header">
          <h3 className="title_xsmall_b">{t('T30003')}</h3>
          {!isRecommendedTireSingleSpec && registeredTire && (
            <button
              type="button"
              className="tire_edit_btn"
              onClick={canChangeTireSpec ? () => openTireSelectionModal() : () => {}}
            >
              {canChangeTireSpec && <span className="ic ic_edit_12px"></span>}
              <span className="tire_name">
                <div>
                  {isFrontRearSameTire ? (
                    registeredFrontTire
                  ) : (
                    <>
                      <div>
                        {registeredFrontTire}({t('T30015')})
                      </div>
                      <div>
                        {registeredRearTire}({t('T30016')})
                      </div>
                    </>
                  )}
                </div>
              </span>
            </button>
          )}
        </div>
        <ul className="tire_pressure_list">
          <li className="tire_pressure_item">
            <span className="tire_pressure_title">{t('T30004')}</span>
            <span className="tire_pressure_value">
              <span className="tire_pressure_number">{registeredTire ? registeredFrontTireBound : '-'}</span>
              <span className="tire_pressure_unit">{pressureUnit}</span>
            </span>
          </li>
          <li className="tire_pressure_item">
            <span className="tire_pressure_title">{t('T30005')}</span>
            <span className="tire_pressure_value">
              <span className="tire_pressure_number">{registeredTire ? registeredRearTireBound : '-'}</span>
              <span className="tire_pressure_unit">{pressureUnit}</span>
            </span>
          </li>
        </ul>

        {!registeredTire && (
          <button
            type="button"
            className="btn btn_large btn_filled btn_full"
            onClick={() => openTireSelectionModal()}
          >
            {t('T30017')}
          </button>
        )}
      </div>
    </>
  );
}

export default RecommendedTirePressure;

export function RecommendedTirePressureError() {
  const {t} = useInferableTranslation();
  return (
    <div className="section_container recommend_pressure">
      <div className="section_container_header">
        <h3 className="title_xsmall_b">{t('T30003')}</h3>
      </div>
      <ul className="tire_pressure_list">
        <li className="tire_pressure_item">
          <span className="tire_pressure_title">{t('T30004')}</span>
          <span className="tire_pressure_value">
            <span className="tire_pressure_number">-</span>
            <span className="tire_pressure_unit">PSI</span>
          </span>
        </li>
        <li className="tire_pressure_item">
          <span className="tire_pressure_title">{t('T30005')}</span>
          <span className="tire_pressure_value">
            <span className="tire_pressure_number">-</span>
            <span className="tire_pressure_unit">PSI</span>
          </span>
        </li>
      </ul>

      <button
        type="button"
        className="btn btn_large btn_filled btn_full"
        disabled
      >
        {t('T30017')}
      </button>
    </div>
  );
}

export function RecommendedTirePressureLoading() {
  const {t} = useInferableTranslation();
  return (
    <div className="section_container">
      <div className="section_container_header skeleton">
        <h3 className="title_xsmall_b">{t('T30003')}</h3>
        <button
          type="button"
          className="tire_edit_btn"
        >
          <span className="ic ic_edit_12px"></span>
        </button>
      </div>
      <ul className="tire_pressure_list skeleton">
        <li className="tire_pressure_item">
          <span className="tire_pressure_title">{t('T30004')}</span>
          <span className="tire_pressure_value">
            <span className="tire_pressure_number">-</span>
            <span className="tire_pressure_unit">PSI</span>
          </span>
        </li>
        <li className="tire_pressure_item skeleton">
          <span className="tire_pressure_title">{t('T30005')}</span>
          <span className="tire_pressure_value">
            <span className="tire_pressure_number">-</span>
            <span className="tire_pressure_unit">PSI</span>
          </span>
        </li>
      </ul>

      <button
        type="button"
        className="btn btn_large btn_filled btn_full skeleton"
        disabled
      >
        {t('T30017')}
      </button>
    </div>
  );
}
